import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { BottomSpyWrapper } from './IntersectionSpy.styles';
export const IntersectionSpy = ({ qaId, onIntersection }) => {
    const element = useRef(null);
    useEffect(() => {
        const observer = new IntersectionObserver((entry) => {
            var _a;
            if ((_a = entry.pop()) === null || _a === void 0 ? void 0 : _a.isIntersecting) {
                onIntersection();
            }
        });
        if (element.current) {
            observer.observe(element.current);
        }
        return () => {
            observer.disconnect();
        };
    }, [element, onIntersection]);
    return _jsx(BottomSpyWrapper, { "data-qa-id": qaId, ref: element }, void 0);
};
